import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { shortName } from "../../../../utils/email-automations";

const SOURCES = {
  membershipType: "membershipTypes",
  location: "locations",
  coach: "coaches",
};

/** The names of the values a filter field holds, by the options of the account or the fixed labels. */
export const valueNames = (field, values, options, t) => {
  const source = options?.[SOURCES[field]];
  return values.map((value) => {
    if (source) {
      const name = source.find((item) => item.id === value)?.name ?? value;
      return field === "coach" ? shortName(name) : name;
    }
    if (field === "startedOnTrial") {
      return t(`emailAutomations.builder.filterModal.${value ? "yes" : "no"}`);
    }
    if (field === "billingFrequency") {
      return t(
        `emailAutomations.builder.filterModal.billingFrequencies.${value}`,
        {
          defaultValue: value,
        }
      );
    }
    if (typeof value === "number") return String(value);
    return t(`emailAutomations.trigger.filterValues.${field}.${value}`, {
      defaultValue: value,
    });
  });
};

/**
 * "Membership is [24/7 Monthly] [24/7 28 Day] and location is [Any]": every field the trigger can
 * be filtered by, with the values it holds (or Any).
 */
const FilterChips = ({ filters, fields, options }) => {
  const { t } = useTranslation("coaching-portal");
  const tr = (key, params) => t(`emailAutomations.builder.${key}`, params);
  return (
    <span className="ab-filter-line">
      {fields.map((field, position) => {
        const values = filters?.[field] ?? [];
        const names = valueNames(field, values, options, t);
        return (
          <span key={field} className="ab-filter-field">
            <span className="ab-filter-text">
              {position > 0 && <>{tr("filter.and")} </>}
              {tr("filter.is", {
                field: tr(`filter.fields.${field}`),
              }).replace(/^./, (letter) =>
                position > 0 ? letter.toLowerCase() : letter
              )}
            </span>
            {(names.length > 0 ? names : [tr("filter.any")]).map((name) => (
              <span
                key={name}
                className={
                  names.length > 0 ? "ab-chip" : "ab-chip ab-chip--any"
                }
              >
                {name}
              </span>
            ))}
          </span>
        );
      })}
    </span>
  );
};

FilterChips.propTypes = {
  filters: PropTypes.object,
  fields: PropTypes.arrayOf(PropTypes.string).isRequired,
  options: PropTypes.object,
};

export default FilterChips;
